import { Button } from '@calizahq/react-components-v2'
import { FollowMutations } from '@sales-app/graphql/mutations/follow.mutations'
import { add } from 'date-fns'
import React, { useState } from 'react'

import { DateInput } from '@/components'
import { useAlertContext } from '@/context'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { formatDate } from '@/util'

type Props = {
  dueDate: Date
  potentialBookingId: number
  refetchOnSuccess: () => void
  toggle: () => void
}

export const AdjustFollowUpTaskDueDates = ({ toggle, dueDate, potentialBookingId, refetchOnSuccess }: Props) => {
  const [adjustedDueDate, setAdjustedDueDate] = useState(dueDate)
  const { setAlert } = useAlertContext()

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(FollowMutations.adjustFollowUpTaskDueDates(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      setAlert('Follow-up Tasks updated.', 'success')
      toggle()
    },
  })

  const handleAdjustFollowUpTaskDueDates = () => {
    mutate({ nextDueDate: formatDate(adjustedDueDate, 'yyyy-MM-dd'), potentialBookingId })
  }

  const today = new Date()
  const tomorrow = add(today, { days: 1 })

  return (
    <div className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <p className="leading-nonemt-4 mb-4 font-bold text-header-md">Adjust follow-up task due dates</p>
      <h5 className="mb-4 text-header-xs leading-120">
        All due dates for the remaining Follow-Up Tasks for this Potential Booking will adjust accordingly based on the
        original frequency of the sequence.
      </h5>
      <DateInput className="max-w-full" handleChange={setAdjustedDueDate} minDate={tomorrow} value={adjustedDueDate} />
      <div className="flex w-full flex-col md:mb-4 md:grid md:grid-cols-2 md:gap-4"></div>
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size="small"
          variant="secondary"
        >
          Close
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isMutationLoading}
          isLoading={isMutationLoading}
          onClick={handleAdjustFollowUpTaskDueDates}
          size="small"
          type="submit"
        >
          Update
        </Button>
      </div>
    </div>
  )
}
